import React from 'react'
import DashboardScoreboardsDevicesMethods from './dashboard__scoreboardDevices.local.methods'
import Card from 'blocks.simple/card/card'
import Animation from 'blocks.simple/animation/animation'
import Link from 'blocks.simple/link/link'

import translate from 'core/translate'
import { routes } from 'features/routes'
import helpers from 'core/helpers'

import styles from './dashboard__scoreboardDevices.jcss'
import { Typography } from 'atoms/Typography'
import { getURLSearchParamsString } from 'features/routes/utils'
import { cn } from 'ethcss'
import { IDashboardScoreboardDevicesProps, ScoreboardStatusKey } from './dashboard__scoreboardDevices.types'

const scoreboardsQueryParam = helpers.prefixQuery({ name: 'scoreboards', field: 'query' })
const scoreboardsPath = routes.scoreboards.path as string

const linkRoutes: Record<ScoreboardStatusKey, { pathname: string; search: string }> = {
    online: {
        pathname: scoreboardsPath,
        search: getURLSearchParamsString({ [scoreboardsQueryParam]: 'online' }),
    },
    offline: {
        pathname: scoreboardsPath,
        search: getURLSearchParamsString({ [scoreboardsQueryParam]: 'offline' }),
    },
    error: {
        pathname: scoreboardsPath,
        search: getURLSearchParamsString({ [scoreboardsQueryParam]: 'error' }),
    },
    notSynchronized: {
        pathname: scoreboardsPath,
        search: getURLSearchParamsString({ [scoreboardsQueryParam]: 'notSynchronized' }),
    },
    updating: {
        pathname: scoreboardsPath,
        search: getURLSearchParamsString({ [scoreboardsQueryParam]: 'updating' }),
    },
}

function DashboardDevices(p_: IDashboardScoreboardDevicesProps) {
    const { s_ } = DashboardScoreboardsDevicesMethods()
    const order = p_.rules?.order ?? 0

    const getStatus = (status: ScoreboardStatusKey, widthValue: number) => {
        if (!s_.data.stats) {
            return null
        }

        const item = s_.data.stats.find((stat) => stat.label === status)

        return item ? (
            <div
                className={cn(styles.statusBlock, widthValue === 0.5 ? styles.halfWidth : styles.fullWidth)}
                style={{
                    backgroundColor: item.color,
                }}
            >
                <Typography type="text" className={styles.title}>
                    {translate(item.label)}
                </Typography>
                <div className={styles.info}>
                    <Link className={styles.link} to={linkRoutes[item.key]}>
                        {item.value}
                    </Link>
                </div>
            </div>
        ) : null
    }

    function renderCard() {
        if (!s_.data.stats) {
            return null
        }

        return (
            <Card
                title={translate('scoreboardsSummary').toUpperCase()}
                icon={{
                    type: 'display',
                    size: 20,
                    default: true,
                }}
            >
                <div className={styles.wrapper}>
                    {getStatus('online', 1)}
                    {getStatus('error', 0.5)}
                    {getStatus('offline', 0.5)}
                    {getStatus('updating', 0.5)}
                    {getStatus('notSynchronized', 0.5)}
                </div>
                <Typography type="text" className={styles.footer}>
                    {translate('scoreboardsTotal')}: {s_.data.devicesCount}
                </Typography>
            </Card>
        )
    }
    return (
        <Animation className={cn(p_.className)} style={{ order }}>
            {renderCard()}
        </Animation>
    )
}

export default React.memo(DashboardDevices)
